import { CommonAPI, Token } from './common'
import {
  MFAChallengeAuthenticatorTOTPVerifyRequest,
  MFAChallengeAuthenticatorTOTPVerifyResponse,
  MFAChallengeEmailOTPRequest,
  MFAChallengeEmailOTPResponse,
  MFAChallengeEmailOTPRetryRequest,
  MFAChallengeEmailOTPRetryResponse,
  MFAChallengeEmailOTPVerifyRequest,
  MFAChallengeEmailOTPVerifyResponse,
  MFAChallengeLarkOTPRequest,
  MFAChallengeLarkOTPResponse,
  MFAChallengeLarkOTPRetryRequest,
  MFAChallengeLarkOTPRetryResponse,
  MFAChallengeLarkOTPVerifyRequest,
  MFAChallengeSmsOTPRequest,
  MFAChallengeSmsOTPResponse,
  MFAChallengeSmsOTPRetryRequest,
  MFAChallengeSmsOTPRetryResponse,
  MFAChallengeSmsOTPVerifyRequest,
  MFAChallengeSmsOTPVerifyResponse,
  MFAInfoResponse,
  MFARemoveAuthenticatorTOTPRequest,
  MFARegisterAuthenticatorTOTPRequest,
  MFARegisterAuthenticatorTOTPRequestResponse,
  MFARegisterAuthenticatorTOTPSetupRequest,
  MFASetPreferredFactorRequest,
  MFAPasskeyRegisterOptionResponse,
  MFAPasskeyRegisterVerifyRequest,
  MFAPasskeyRegisterVerifyResponse,
  MFAPasskeyAuthenticationOptionResponse,
  MFAPasskeyAuthenticationVerifyRequest,
  MFAPasskeyAuthenticationVerifyResponse
} from './types'

import { baseURL } from './constants'

export class MfaAuthAPI extends CommonAPI {
  constructor(token: Token) {
    super({ baseURL })

    this.filterRequestPayload()

    this.updateToken(token)
  }

  public mfaInfoRequest = () => {
    return this.api.get<MFAInfoResponse>('/mfa/info')
  }

  public mfaChallengeEmailOTPRequest = (data: MFAChallengeEmailOTPRequest) => {
    return this.api.post<MFAChallengeEmailOTPResponse>(
      '/mfa/challenge/email_otp/request',
      data
    )
  }

  public mfaChallengeEmailOTPRetry = (
    data: MFAChallengeEmailOTPRetryRequest
  ) => {
    return this.api.post<MFAChallengeEmailOTPRetryResponse>(
      '/mfa/challenge/email_otp/retry',
      data
    )
  }

  public mfaChallengeEmailOTPVerify = (
    data: MFAChallengeEmailOTPVerifyRequest
  ) => {
    return this.api.post<MFAChallengeEmailOTPVerifyResponse>(
      '/mfa/challenge/email_otp/verify',
      data
    )
  }

  public mfaChallengeSmsOTPRequest = (data: MFAChallengeSmsOTPRequest) => {
    return this.api.post<MFAChallengeSmsOTPResponse>(
      '/mfa/challenge/sms_otp/request',
      data
    )
  }

  public mfaChallengeSmsOTPRetry = (data: MFAChallengeSmsOTPRetryRequest) => {
    return this.api.post<MFAChallengeSmsOTPRetryResponse>(
      '/mfa/challenge/sms_otp/retry',
      data
    )
  }

  public mfaChallengeSmsOTPVerify = (data: MFAChallengeSmsOTPVerifyRequest) => {
    return this.api.post<MFAChallengeSmsOTPVerifyResponse>(
      '/mfa/challenge/sms_otp/verify',
      data
    )
  }

  public mfaChallengeLarkOTPRequest = (data: MFAChallengeLarkOTPRequest) => {
    return this.api.post<MFAChallengeLarkOTPResponse>(
      '/mfa/challenge/lark_otp/request',
      data
    )
  }

  public mfaChallengeLarkOTPRetry = (data: MFAChallengeLarkOTPRetryRequest) => {
    return this.api.post<MFAChallengeLarkOTPRetryResponse>(
      '/mfa/challenge/lark_otp/retry',
      data
    )
  }

  public mfaChallengeLarkOTPVerify = (
    data: MFAChallengeLarkOTPVerifyRequest
  ) => {
    return this.api.post<MFAChallengeSmsOTPVerifyResponse>(
      '/mfa/challenge/lark_otp/verify',
      data
    )
  }

  public mfaChallengeAuthenticatorTOTPVerify = (
    data: MFAChallengeAuthenticatorTOTPVerifyRequest
  ) => {
    return this.api.post<MFAChallengeAuthenticatorTOTPVerifyResponse>(
      '/mfa/challenge/totp/verify',
      data
    )
  }

  public mfaSetPreferredFactor = ({ type }: MFASetPreferredFactorRequest) => {
    return this.api.put(`/mfa/set-preferred-factor/${type}`)
  }

  public mfaRegisterAuthenticatorTOTPRequest = (
    data: MFARegisterAuthenticatorTOTPRequest
  ) => {
    return this.api.post<MFARegisterAuthenticatorTOTPRequestResponse>(
      '/mfa/register/totp/request',
      data
    )
  }

  public mfaRemoveAuthenticatorTOTP = (
    data: MFARemoveAuthenticatorTOTPRequest
  ) => {
    return this.api.post('/mfa/remove/totp', data)
  }

  public mfaRegisterAuthenticatorTOTPSetup = (
    data: MFARegisterAuthenticatorTOTPSetupRequest
  ) => {
    return this.api.post('/mfa/register/totp/setup', data)
  }

  public mfaPasskeyRegisterOption = () => {
    const data = {
      server_host: self.origin
    }

    return this.api.post<MFAPasskeyRegisterOptionResponse>(
      '/mfa/register/passkey/option',
      data
    )
  }

  public mfaPasskeyRegisterVerify = (data: MFAPasskeyRegisterVerifyRequest) => {
    return this.api.post<MFAPasskeyRegisterVerifyResponse>(
      '/mfa/register/passkey/verify',
      data
    )
  }

  public mfaPasskeyAuthenticationOption = () => {
    const data = {
      server_host: self.origin
    }

    return this.api.post<MFAPasskeyAuthenticationOptionResponse>(
      '/mfa/challenge/passkey/option',
      data
    )
  }

  public mfaPasskeyAuthenticationVerify = (
    data: MFAPasskeyAuthenticationVerifyRequest
  ) => {
    return this.api.post<MFAPasskeyAuthenticationVerifyResponse>(
      '/mfa/challenge/passkey/verify',
      data
    )
  }
}
